import classnames from 'classnames';

import styles from 'components/ProductListing/ProductCard/product-card.module.scss';

import type { FC } from 'react';

interface ProductCardProps {
  productType: string;
  body: string;
}

const ProductCard: FC<ProductCardProps> = ({ productType, body }) => (
  <div
    className={classnames(styles.productCard, {
      [styles[productType.toLowerCase()]]: productType,
    })}
  >
    <div className={styles.productTypeHeader}>
      <div className={styles.productLabel}>
        <span className={styles.productLabelBold}>{productType}</span>
        <span className={styles.productLabelNormal}> of Medicine </span>
      </div>
    </div>
    <p className={styles.productBody}>{body}</p>
  </div>
);

export default ProductCard;
